module.exports = __webpack_public_path__ + "assets/img/spitch-icon.225b3115.png";